const NameFormatter = {
  format: (toFormat) => {
    if (!toFormat) return ''
    return toFormat.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s]+/g, '')
  }
}

export default NameFormatter
